import React, { Component } from 'react';

import numeral from 'numeral';
import Clipboard from 'react-clipboard.js';

import { genPayData2, isWexin, isMobile, isAlipay } from '../../../utils';

import QRCode from 'qrcode.react';

import logo from '../../../assets/logo.svg';

import alipayBtnImg from '../../../assets/btn-alipay.svg';
import wechatBtnImg from '../../../assets/btn-wechat.svg';

import img from '../../../assets/bg_top_right.svg';
import btmLeftImg from '../../../assets/bg_btm_left.svg';
import api from '../../../api';

import wechatLogo from '../../../assets/ic_wechat.svg';
import aliLogo from '../../../assets/ic_alipay.svg';
import moneymoreLogo from '../../../assets/ic_latipay.svg';
import unionpayLogo from '../../../assets/ic_upi_qr_code.svg';

import './index.css';

const polling_interval = 3000;

const azupayBanks = [
  {
    name: 'ANZ',
    mobileApp: [
      'Tap the $ Pay icon on the Accounts tab',
      'Tap on the + to make a payment to a new PayID',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    desktopBrowser: [
      'Select the Payments menu, then Pay Anyone',
      'Select an account to make your payment from',
      'Select Add a new payee',
      'Choose Add a new payment type, select Email address',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    notes: []
  },
  {
    name: 'Bendigo Bank',
    mobileApp: [
      'Select the Pay Anyone icon and add New Payee',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    desktopBrowser: [
      'Click on Move Money',
      'Click Pay Anyone',
      'Click New payee',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    notes: []
  },
  {
    name: 'Commonwealth Bank',
    mobileApp: [
      'Select Pay someone from the homepage',
      'Select the + sign in the top right-hand corner',
      'From the menu of options, click more and then select Email address',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    default: true,
    notes: []
  },
  {
    name: 'ING - $1,000 daily limit on all PayID payments',
    mobileApp: [
      'Tap Pay, then Pay anyone',
      'Choose the account you wish to make the payment from',
      'Choose +New payee, then select PayID',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    desktopBrowser: [
      'Go to Transfer & pay, then Pay anyone',
      'Choose +New payee, then select PayID',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    notes: ['ING currently has a $1,000 daily limit on all PayID payments']
  },
  {
    name: 'Macquarie Bank',
    mobileApp: [
      'Select the $ icon on the front screen',
      'Select Make a payment',
      'Add a new PayID by selecting Pay new',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    desktopBrowser: [
      'Select the $ icon on the side menu',
      'Select the account the payment should come from',
      'Add a new payee (PayID)',
      'Select Email and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    notes: []
  },
  {
    name: 'NAB',
    mobileApp: [
      'Select the account you want to transfer from',
      'Tap Pay and then Pay Anyone',
      'Tap Mobile/PayID',
      'Select Email Address and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    desktopBrowser: [
      'Once you’ve logged in, click Funds Transfer and choose Pay to a PayID',
      'Under PayID type',
      'Select Email and enter the email address provided from the checkout',
      'Select Next to proceed',
      'Choose the account you wish to pay from',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    notes: []
  },
  {
    name: 'Suncorp',
    mobileApp: [
      'Select Pay/Transfer, followed by Pay Someone',
      'When you have selected your Account to pay from, tap Select Payee, then New Payee',
      'Select Email Address and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification',
      'Review the transaction and finalise the payment'
    ],
    notes: []
  },
  {
    name: 'Westpac',
    mobileApp: [
      'Tap the Pay icon',
      'Under From, select the account you want to make a payment from',
      'Under To, tap Choose a payee or biller',
      'Add a new PayID payee by selecting + Add',
      'Tap New PayID/Mobile payee',
      'Select Email Address and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification'
    ],
    desktopBrowser: [
      'In the Payments tab, select Make a payment',
      'Add a new PayID payee by selecting Pay new payee',
      'Under I want to pay - choose Email Address and enter the email address provided from the checkout',
      'Enter the amount that appears on the checkout and from the PayID verification'
    ],
    notes: []
  },
  {
    name: "My bank isn't here",
    mobileApp: [
      'Open your mobile banking app',
      'Choose to pay anyone',
      'Use the pay by email option',
      'Enter or paste the PayID',
      'Validate the PayID is correct',
      'Enter the amount',
      'Pay'
    ],
    desktopBrowser: [
      'Open your online banking in a new tab',
      'Choose to pay anyone',
      'Use the pay by email option',
      'Enter or paste the PayID',
      'Validate the PayID is correct',
      'Enter the amount',
      'Pay'
    ],
    notes: [
      'Some banks will delay the payment for up to 24 hours. Rest assured that your payment will go through.'
    ]
  }
];

const azupayBanksMap = azupayBanks.reduce((result, item) => {
  result[item.name] = item;
  return result;
}, {});

const icons = {
  wechat: wechatLogo,
  alipay: aliLogo,
  latipay: moneymoreLogo,
  upi_qr_code: unionpayLogo
};

const titles = {
  wechat: 'WeChat Pay',
  alipay: 'Alipay',
  latipay: 'MoneyMore',
  polipay: 'NZ bank account',
  upi_qr_code: 'UnionPay',
  azupay: 'PayID',
  coin_payments: 'Crypto',
  payid: 'PayID' //added by Edison Tsai on 16:34 2024/02/07 for add a new payment method
};

const env = process.env.REACT_APP_DEPLOY_ENV || 'staging';

const btnImgs = {
  alipay: alipayBtnImg,
  wechat: wechatBtnImg
};

const REACT_APP_ROOT_URL = process.env.REACT_APP_ROOT_URL || '';

export default class Page extends Component {
  constructor(props) {
    super(props);

    const { organisationCode, shortCode } = this.props.match.params;

    const params = new URLSearchParams(window.location.search);

    const amount = params.get('amount');

    if (!amount && organisationCode && shortCode) {
      window.location = `${
        window.location.origin
      }${REACT_APP_ROOT_URL}/${organisationCode}/${shortCode}`;
      return;
    }

    const particulars = params.get('particulars');
    const referenceCode = params.get('referenceCode');
    const reference = params.get('reference');

    const fromBackurl = params.get('from_backurl');
    const retry_url = params.get('retry_url');

    let unionpayQRCode = params.get('qr_code');
    if (unionpayQRCode) {
      unionpayQRCode = decodeURIComponent(unionpayQRCode.replace(/\+/g, ' '));
    }
	//modified by Edison Tsai on 22:47 2024/02/07 for use new variable to store pay_id
    const strPayId = params.get('pay_id');
    const orderId = params.get('order_id'); //unionpay, azupay, payid, or coin_payments order id for query

    let gateway = params.get('gateway'); //wechat, alipay, latipay, upi_qr_code, azupay, coin_payments, payid(monoova api)

    if (isWexin && (gateway === 'alipay' || gateway === 'latipay')) {
      gateway = 'wechat';
    } else if (isAlipay && (gateway === 'alipay' || gateway === 'latipay')) {
      gateway = 'alipay';
    }

    this.state = {
      referenceOpened: false,
      data: {},
      unionpayQRCode,
      orderId,

      amount,
      particulars,
      referenceCode,
      reference,

      strPayId,

      gateway,
      inMobile: isMobile(),

      fromBackurl,
      selectGateway: params.get('gateway'),
      retry_url,
      azupayBank: azupayBanks[0].name,
      address: params.get('address'),
      currency: params.get('currency')
    };
  }

  async componentDidMount() {
    var {
      gateway,
      fromBackurl,
      amount,
      inMobile,
      unionpayQRCode,
      orderId
    } = this.state;
    if (!amount) {
      return;
    }

    const { organisationCode, shortCode } = this.props.match.params;

    if (organisationCode && shortCode) {
      const { data } = await api.staticQR.getWalletInfoByCompany(
        organisationCode,
        shortCode
      );

      if (data.code === 0) {
        const obj = {
          data
        };

        if (data.amount) {
          obj.amount = data.amount;
        }
        this.setState(obj);
      } else {
        alert(data.message || data.messageCN || 'Invalid qr code');
      }
    } else {
      //payid
    }

    if (
      !fromBackurl &&
      ((gateway === 'wechat' && isWexin) ||
        (gateway === 'alipay' && isAlipay) ||
        (gateway === 'latipay' && inMobile))
    ) {
      //第一次自动pay
      this.pay();
    }

    if (
      orderId &&
      (sessionStorage.getItem('paymentQRCode') ||
        unionpayQRCode ||
        gateway === 'azupay' || gateway === 'payid' ||
        gateway === 'coin_payments')
    ) {
      setTimeout(this.queryOrder.bind(this), polling_interval);
    }
  }

  async queryOrder() {
    const { orderId, amount, gateway, retry_url } = this.state;

    const { data } = await api.transaction.query(orderId);
    const { code, status, discounts, currency, returnUrl } = data || {};

    if (code === 0) {
      if (status === 'pending' || status === 'locked') {
        setTimeout(this.queryOrder.bind(this), polling_interval);
      } else {
        if (returnUrl) {
          window.location.replace(returnUrl);
        } else {
          const statusText = status === 'success' ? 'paid' : status;
          const query = {
            status: statusText,
            amount,
            currency,
            order_id: orderId,
            payment_method: titles[gateway] || gateway,
            noads: true
          };
          if (retry_url && statusText !== 'paid') {
            query.retry_url = retry_url;
          }
          if (discounts && discounts.length > 0) {
            query.discounts = encodeURIComponent(JSON.stringify(discounts));
          }

          const url =
            window.location.origin +
            `${REACT_APP_ROOT_URL}/result?${new URLSearchParams(
              query
            ).toString()}`;
          window.location.replace(url);
        }
      }
    }
  }

  pay = () => {
    const {
      gateway,
      particulars,
      referenceCode,
      reference,
      data,
      amount
    } = this.state;

    if (gateway === 'upi_qr_code') {
      return;
    }

    if (gateway === 'latipay') {
      //手机safari 可能 仍停留在preveiw页面，需要再次跳转到/pay处理
      const { organisationCode, shortCode } = this.props.match.params;

      const back = encodeURIComponent(window.location.href);

      let url = `https://m${
        env === 'staging' ? '-staging' : ''
      }.latipay.net/pay?type=qrcode&organisationCode=${organisationCode}&shortCode=${shortCode}&amount=${amount}&back=${back}`;

      if (particulars) url += `&particulars=${particulars}`;
      if (referenceCode) url += `&referenceCode=${referenceCode}`;
      if (reference) url += `&reference=${reference}`;

      window.location = url;
      return;
    }

    //
    if (isWexin || gateway === 'alipay') {
      const { userCode, accountCode, currency } = data;

      this.setState({ isPaying: true });

      const payData = genPayData2(
        { amount, reference, qr_code_id: data.id },
        {
          user_id: userCode,
          wallet_id: accountCode,
          payment_method: gateway,
          currency,
          returnUrl: `${window.location.origin}${REACT_APP_ROOT_URL}/result`
        },
        {
          particulars,
          referenceCode,
          reference
        }
      );

      api.transaction.init(payData);
    } else {
      //out of wechat app
    }
  };

  select = gateway => () => {
    this.setState({
      gateway
    });
  };

  change = key => e => {
    this.setState({
      [key]: e.target.value
    });
  };

  openReference = () => {
    this.setState(pre => ({
      referenceOpened: !pre.referenceOpened
    }));
  };

  goBack = () => {
    sessionStorage.removeItem('paymentQRCode');
    window.history.back();
  };

  saveQRCode = () => {
    var canvas = document.getElementById('qrcode_canvas');
    // var image = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    const { amount, data } = this.state;
    const { qrName } = data;

    var filename = `${qrName}_${amount}`.replace(/[^a-z0-9]/gi, '_');
    link.setAttribute('download', `UnionPay ${filename}.png`);

    link.setAttribute(
      'href',
      canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    );
    link.click();
  };

  copy = () => {
    this.setState(
      {
        copied: true
      },
      () => {
        setTimeout(() => {
          this.setState({
            copied: false
          });
        }, 1000);
      }
    );
  };

  handleAzupayChange = e => {
    this.setState({
      azupayBank: e.target.value
    });
  };

  render() {
    const {
      gateway,
      particulars,
      referenceCode,
      reference,
      data,
      amount,
      inMobile,
      selectGateway,
      strPayId,
      copied,
      azupayBank,
      address
    } = this.state;

    if (!amount) {
      return <div />;
    }

    const { accountCode } = data;
    const currency = this.state.currency || data.currency;

    let qrCodeText = this.state.unionpayQRCode;
    if (gateway === 'azupay' || gateway === 'payid') {
      qrCodeText = window.location.href;
    } else {
      const params = new URLSearchParams(window.location.search);
      const qr_code_url = params.get('qr_code_url');
      if (qr_code_url) {
        qrCodeText = qr_code_url;
      }
    }

    const paymentQRCode = sessionStorage.getItem('paymentQRCode');
    if (!qrCodeText && !paymentQRCode) {
      let search = `?amount=${amount}`;
      if (gateway) search += `&gateway=${gateway}`;
      if (particulars) search += `&particulars=${particulars}`;
      if (referenceCode) search += `&referenceCode=${referenceCode}`;
      if (reference) search += `&reference=${reference}`;

      qrCodeText = window.location.origin + window.location.pathname + search;
    }

    var scanTips = '- Scan QR code -';
    if (selectGateway === 'wechat') {
      scanTips = (
        <div>
          Scan QR code by <strong style={{ color: '#4a90e2' }}>WeChat</strong>{' '}
          APP
        </div>
      );
    } else if (selectGateway === 'alipay') {
      scanTips = (
        <div>
          Scan QR code by <strong style={{ color: '#4a90e2' }}>Alipay</strong>{' '}
          APP
        </div>
      );
    } else if (selectGateway === 'upi_qr_code') {
      scanTips = (
        <div>
          Scan QR code by <strong style={{ color: '#4a90e2' }}>云闪付</strong>{' '}
          APP
        </div>
      );
    } else if (selectGateway === 'latipay') {
      scanTips = 'Scan QR code by MoneyMore APP';
    }

    const { organisationCode, shortCode } = this.props.match.params;

    let toCopy = '';
    if (strPayId.length > 0) {
      toCopy = strPayId;
    } else if (gateway === 'coin_payments') {
      toCopy = address;
    }

    return (
      <div className="pg pg-staticqr-preview">
        <div className="card">
          <div className="container">
            <img style={{ zIndex: 1, display: 'none', visibility: 'hidden' }} src={logo} alt="latipay" />
            <img className="img-top-right" src={img} alt="" />

            <div className="preview">
              <div className="centered">
                <div className="merchant-name">{data.qrName}</div>
                <div className="tips">{scanTips}</div>

                <div>
                  <div className="payment-amount">Payment Amount</div>
                  <div className="amount">
                    {gateway === 'coin_payments' &&
                      numeral(amount).format('0,0.00000')}
                    {gateway !== 'coin_payments' &&
                      numeral(amount).format('0,0.00')}
                    <span>{currency}</span>
                  </div>
                </div>

                {toCopy && (
                  <div>
                    <div
                      className="preview-value"
                      style={{
                        color: '#68C371',
                        textAlign: 'center',
                        fontSize: gateway === 'coin_payments' ? 12 : 16,
                        marginBottom: 15
                      }}
                    >
                      {toCopy}{' '}
                      <Clipboard
                        className="preview-btn_azupay_copy"
                        data-clipboard-text={toCopy}
                        onSuccess={this.copy}
                      >
                        <div style={{ position: 'relative' }}>
                          {copied && (
                            <div
                              style={{
                                position: 'absolute',
                                fontSize: 10,
                                color: 'black',
                                bottom: -15
                              }}
                            >
                              Copied
                            </div>
                          )}
                          <span>COPY</span>
                        </div>
                      </Clipboard>
                    </div>
                  </div>
                )}
                {qrCodeText && (
                  <QRCode
                    id="qrcode_canvas"
                    size={220}
                    value={qrCodeText}
                    bgColor="#f8f8f8"
                    includeMargin={true}
                    imageSettings={{
                      src: icons[selectGateway] || '',
                      width: 40,
                      height: 40
                    }}
                  />
                )}
                {paymentQRCode && <img src={paymentQRCode} alt={gateway} />}

                {gateway === 'wechat' &&
                  inMobile && (
                    <div className="green-tips">
                      可以截屏保存二维码
                      <br />
                      并使用微信打开完成付款。
                    </div>
                  )}

                {(gateway === 'azupay' || gateway === 'payid') && (
                  <div className="azupay-tips">
                    Scan the QR code to pay with banking app
                  </div>
                )}
              </div>
              <div className="flexed-container">
                {(particulars || referenceCode || reference) && (
                  <div className="flexed">
                    <div className="preview-title">Reference</div>
                    <div className="preview-value">
                      {[particulars, referenceCode, reference]
                        .filter(item => !!item)
                        .join(' ')}
                    </div>
                  </div>
                )}
              </div>

              {gateway === 'upi_qr_code' && (
                <div
                  style={{
                    marginTop: '10px',
                    textAlign: 'center',
                    color: '#555',
                    fontSize: '0.88em'
                  }}
                >
                  1. Please{' '}
                  <span className="link" onClick={this.saveQRCode}>
                    save the QR code
                  </span>{' '}
                  or screenshot;
                  <br />
                  2. Open UnionPay app; <br />
                  3. Scan the QR code and pay.
                </div>
              )}

              {(gateway === 'azupay' || gateway === 'payid') && (
                <select
                  className="azupay_select minimal"
                  onChange={this.handleAzupayChange}
                >
                  {azupayBanks.map(item => (
                    <option key={item.name} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              )}
              {(gateway === 'azupay' || gateway === 'payid') &&
                (azupayBanksMap[azupayBank].mobileApp || []).length > 0 && (
                  <React.Fragment>
                    <h5 style={{ margin: '15px 0 10px', padding: 0 }}>
                      Mobile App
                    </h5>
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: 15,
                        paddingRight: 10,
                        color: '#555',
                        fontSize: '0.86em'
                      }}
                    >
                      {azupayBanksMap[azupayBank].mobileApp.map(
                        (item, index) => (
                          <li key={index}>{item}</li>
                        )
                      )}
                    </ul>
                  </React.Fragment>
                )}

              {(gateway === 'azupay' || gateway === 'payid') &&
                (azupayBanksMap[azupayBank].desktopBrowser || []).length >
                  0 && (
                  <React.Fragment>
                    <h5 style={{ margin: '20px 0 10px', padding: 0 }}>
                      Desktop Browser
                    </h5>
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: 15,
                        paddingRight: 10,
                        color: '#555',
                        fontSize: '0.86em'
                      }}
                    >
                      {azupayBanksMap[azupayBank].desktopBrowser.map(
                        (item, index) => (
                          <li key={index}>{item}</li>
                        )
                      )}
                    </ul>
                  </React.Fragment>
                )}

              <div
                style={{
                  marginTop: '40px',
                  marginBottom: '30px'
                }}
              >
                {accountCode &&
                  ((gateway === 'wechat' && isWexin) ||
                    gateway === 'alipay' ||
                    gateway === 'latipay') && (
                    <div
                      className={`preview-btn preview-btn_${gateway}`}
                      onClick={this.pay}
                    >
                      {gateway === 'latipay' && '使用钱多多APP付款'}
                      {gateway !== 'latipay' && (
                        <img src={btnImgs[gateway]} alt="" />
                      )}
                    </div>
                  )}
              </div>
              <div className="btn-choose-other" onClick={this.goBack}>
                Choose another payment mothod
              </div>
            </div>

            <img className="img-btm-left" src={btmLeftImg} alt="" />
          </div>
        </div>

        {/*
  <ToastContainer
    position="top-center"
    hideProgressBar={true}
    closeOnClick={true}
    transition={Slide}
    autoClose={2000}
    limit={1}
  />
  */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/OfflineApiOrder/StaticQR2Preview/index.js